import { useStickyParam } from '../storage/useStickyParam';

export const useReferralToken = () => useStickyParam({
  searchName: 'referral-token',
  cookieName: 'referral_token',
  expirationDays: 1,
});
